import { Button, Card, Checkbox, Col, Form, Input, Row } from "antd";
import { useMutation } from "react-query";
import { signInAnonymously, updateProfile } from "firebase/auth";
import { LoadingOverlay } from "../components/LoadingOverlay";
import { auth } from "../utils/firebase/setupFirebase";
import { delay } from "lodash";
import { OurLayoutForNormalPages } from "../components/OurLayout";
import { Helmet } from "react-helmet-async";

type FormValues = {
  displayName: string;
  agb: boolean;
  datenschutz: boolean;
};

export const SignInScreen = () => {
  const createUserMutation = useMutation(
    async (data: FormValues) => {
      const userCredential = await signInAnonymously(auth);

      await updateProfile(userCredential.user, {
        displayName: data.displayName,
      });
      await delay(() => {}, 2000);
    },
    {
      onSuccess: () => {
        window.location.reload();
      },
    }
  );

  return (
    <OurLayoutForNormalPages>
      <Helmet title={"Anmeldung"} />

      <Row style={{ width: "100%" }} justify={"center"}>
        <Col span={24} md={12} lg={8}>
          <Card title={"Anmelden"}>
            {createUserMutation.isLoading && <LoadingOverlay />}
            <Form
              onFinish={(data) => {
                createUserMutation.mutate(data);
              }}
              layout={"vertical"}
            >
              <Form.Item
                rules={[{ required: true, message: "Gib einen Namen an." }]}
                name={"displayName"}
                label={"Wie willst du beim spielen genannt werden?"}
              >
                <Input />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(),
                    message:
                      "Bitte lese unsere Nutzungsbedingungen und stimme Ihnen zu.",
                  },
                ]}
                valuePropName={"checked"}
                name={"agb"}
                label={"Nutzungsbedingungen"}
              >
                <Checkbox>
                  Ich habe die{" "}
                  <a
                    rel={"noreferrer"}
                    href={
                      "https://mayasolutions.de/nutzungsbedingungen-werbinich-web-app"
                    }
                    target={"_blank"}
                  >
                    Nutzungsbedingungen
                  </a>{" "}
                  gelesen und akzeptiere sie.
                </Checkbox>
              </Form.Item>
              <Form.Item
                valuePropName={"checked"}
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(),
                    message:
                      "Bitte lese unsere Datenschutzerklärung und stimme Ihnen zu.",
                  },
                ]}
                name={"datenschutz"}
                label={"Datenschutz"}
              >
                <Checkbox>
                  Ich habe die{" "}
                  <a
                    rel={"noreferrer"}
                    href={
                      "https://mayasolutions.de/datenschutzerklaerung-fuer-werbinich-web-app"
                    }
                    target={"_blank"}
                  >
                    Datenschutzerklärung
                  </a>{" "}
                  gelesen und akzeptiere sie.
                </Checkbox>
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  lg: {
                    offset: 12,
                  },
                }}
              >
                <Button type="primary" htmlType="submit">
                  Anmelden
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </OurLayoutForNormalPages>
  );
};
